import { Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_FORMFIELD, KENDO_RADIOBUTTON } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { KENDO_STACKLAYOUT } from '@progress/kendo-angular-layout';
import { ErrorWrapperComponent } from '@unity/forms/composed/error-wrapper/error-wrapper.component';

@Component({
  selector: 'unity-radio-confirmation-control',
  standalone: true,
  imports: [KENDO_FORMFIELD, KENDO_RADIOBUTTON, KENDO_STACKLAYOUT, KENDO_LABEL, ReactiveFormsModule, ErrorWrapperComponent],
  templateUrl: './radio-confirmation-control.component.html',
  styleUrl: './radio-confirmation-control.component.scss',
})
export class RadioConfirmationControlComponent {
  public readonly $control = input.required<FormControl<boolean>>({ alias: 'control' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });

  public readonly $showHint = input(true, { alias: 'showHint' });

  public selectionChangeEvent = output<boolean>();

  protected onChange(value: boolean) {
    this.$control().setValue(value);
    this.selectionChangeEvent.emit(value === true);
  }
}
